import { ComponentConfig } from "@measured/puck";
import QuoteBlockRender from "./QuoteBlockRender";
import WysiwygField from "../../Fields/WysiwygField";

const QuoteBlock: ComponentConfig<{ text: string }> = {
    fields: {
        // @ts-ignore
        text: {
            // @ts-ignore
            ...WysiwygField.fields.editor,
            label: 'Tekst'
        },
    },
    render: (props) => (
        <QuoteBlockRender {...props} />
    ),
}

export default QuoteBlock;
